import React, { Fragment } from 'react';
import { Alert } from 'reactstrap';
import ReactTooltip from 'react-tooltip';

const TagTable = (props) => {
  // ----------------------
  // Render
  // ----------------------

  return (
    <Fragment>
      {!props.tags.length ? (
        <Alert color="primary">No Tags for selected filters</Alert>
      ) : (
        <table className="table table-stripped">
          <thead>
            <tr>
              <th>
                <div className="header">
                  <span>Name </span>
                </div>
              </th>
              <th>
                <div className="header">
                  <span>Actions </span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {props.tags.map((tag, index) => {
              return (
                <tr key={index.toString()}>
                  <td>{tag.name}</td>
                  <td className="td-actions">
                    <ReactTooltip
                      className="customTheme"
                      effect="solid"
                      place="top"
                    />
                    <button
                      className="button default small"
                      data-tip="Edit"
                      onClick={() => props.onEdit(tag.guid)}
                    >
                      <i className="fa fa-edit" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Fragment>
  );
};

export default TagTable;
